import type { APP_TYPE } from 'hb-react/types/appType';

interface Routes {
  publicoffice?: {
    network: {
      index: any;
      show?: any;
    };
    topic: {
      index: any;
      show?: any;
    };
  };
  frontoffice?: {
    network: {
      index: any;
      show?: any;
    };
    topic: {
      index: any;
      show?: any;
    };
  };
}

export const getApiDynamicComponentBaseEndpoint = ({
  app,
  topicId,
  routes,
  id,
}: {
  app: APP_TYPE;
  topicId?: number | null;
  routes: Routes;
  id?: number | null;
}) => {
  const params: number[] = [];

  if (topicId) {
    params.push(topicId);
  }

  if (id) {
    params.push(id);
  }

  return routes[app][topicId ? 'topic' : 'network'][id ? 'show' : 'index'](
    ...params,
  );
};
